'use strict';

import { SystemStorageType } from '../../../../App/model/system-storage-types';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.GlobalSearchController', MxGlobalSearchCtrl);

MxGlobalSearchCtrl.$inject = [
	'$q',
	'$timeout',
	'$scope',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.shell.UserProfileService',
	'mx.shell.DataStorage',
	'mx.internationalization',
	'mx.shell.SearchProviderService',
	'mx.shell.NavigationService',
	'mx.SolutionBuilderAgent.DataQueryService',
	'mx.SolutionBuilderAgent.DataModelService',
	'mx.shell.ObjectMapper',
	'mx.shell.ContextService',
	'mx.shell.Config',
	'mx.shell.EventService',
];

function MxGlobalSearchCtrl(
	$q,
	$timeout,
	$scope,
	contentWidgetService,
	columnDefinitionService,
	externalServiceManager,
	personalizationService,
	userProfileService,
	dataStorage,
	i18n,
	searchService,
	navigationService,
	dataQueryService,
	dataModelService,
	objectMapper,
	contextService,
	configService,
	eventService
) {
	const vm = this;

	vm.i18n = i18n.get('solutionBuilderAgent.common');
	vm.loading = true;

	vm.uiToken = 'uiToken:search-page-content';
	contextService.val('globalUiToken', vm.uiToken);

	const storage = dataStorage.getStorage(SystemStorageType.LocalStorage);
	const freeDataSourceDefer = $q.defer();

	init();

	$scope.$on('$destroy', function () {
		freeDataSourceDefer.resolve(true);
	});

	async function init() {
		const contextPromise = searchService.getCurrentGlobalSearchParameters();
		const userProfilePromise = userProfileService.get();
		const pageSizePromise = personalizationService.getPageSize();

		const [globalSearchParameters, userProfile, personalizedPageSize] = await $q.all([contextPromise, userProfilePromise, pageSizePromise]);

		$timeout(async function () {
			if (globalSearchParameters.navigationId) {
				const nav = await navigationService.getNavigationItem(globalSearchParameters.navigationId);
				navigationService.setActiveStatus(navigationService.currentItem, false);
				navigationService.setActiveStatus(nav, true);
			} else {
				navigationService.setExtraItem(vm.i18n.search);
			}
		}, 400);

		const pageSize = parseInt(personalizedPageSize || (configService.get('dataSource') || {}).pageSize, 10) || 20;
		const selectedContexts = globalSearchParameters.contexts.filter((context) => context.selected);
		const contexts = selectedContexts.length > 0 ? selectedContexts : globalSearchParameters.contexts;

		const _makeItemForQueryInfo = makeItemForQueryInfo(userProfile);

		let queries = contexts.map(mapContextToQuery).filter((item) => item.dataQueryId && item.widgetId);

		const data = await dataQueryService.getGlobalSearchData({
			keyword: globalSearchParameters.keyword,
			objectsForSearch: queries.map(_makeItemForQueryInfo),
			pageSize: pageSize,
		});
		let results = data
			.filter((item) => item.Count)
			.map((result) => {
				const resultFilterId = result.Filters[0] || '';
				const resultStructureId = result.StructureNodeId || '';

				const query = queries.find(
					({ widgetId, filterId = '', filterType }) =>
						widgetId === result.WidgetId &&
						(filterType === 'nofilter' || (filterType === 'filter' && filterId === resultFilterId) || (filterType === 'structure' && filterId === resultStructureId))
				);

				if (query) {
					result.title = query.title;
					result.name = query.name;
					result.navigationId = query.navigationId;
				} else {
					console.error(`GlobalSearch: result from server (DataQueryId: ${result.DataQueryId}, WidgetId: ${result.WidgetId}) cannot be find in queries`);
				}

				result.DataQuery = columnDefinitionService.initDataQuery(result.DataQuery);

				result.viewParameters = {
					uiToken: vm.uiToken,
					dataQuery: result.DataQuery,
					data: result.Data && result.Data.map(objectMapper.mapItem),
					totalCount: result.Count,
					dataQueryId: result.DataQueryId,
					id: result.WidgetId,
					entities: Array.isArray(result.ContentWidgetList.Entities) ? result.ContentWidgetList.Entities.map((entity) => entity.Name) : null,
					pageSize: pageSize,
					structureNodeId: result.StructureNodeId,
				};

				result.searchOptions = {
					context: angular.copy(searchService.getGlobalSearchContext()),
					keyword: globalSearchParameters.keyword,
					uiToken: vm.uiToken,
					filters: result.Filters,
				};

				makeTemplateLoader(result);

				return result;
			});

		vm.results = results.sort((a, b) => b.Count - a.Count);

		await loadServiceBasedDataSets(globalSearchParameters.keyword);

		vm.selectedIndex = 0;
		$scope.$watch('vm.selectedIndex', (index) => {
			changeTabContext(index);
		});
		$timeout(() => {
			vm.loading = false;
		}, 50);
	}

	async function loadServiceBasedDataSets(keyword) {
		const services = vm.results.filter((result) => result.Count === -1);
		if (services.length === 0) {
			return;
		}

		const currentSearch = searchService.currentSearch();
		currentSearch.keyword = keyword;
		await services.map((service) => service.load());

		await new Promise((resolve) => {
			const unsubscribe = eventService.subscribeTo(
				mx.SolutionBuilderAgent.Events.SearchPageReloaded,
				function () {
					$scope.$evalAsync(async () => {
						const loaded = services.every((dataSet) => dataSet.viewParameters?.dataQueryList.loading === false);

						if (loaded) {
							unsubscribe();
							services.forEach((service) => (service.Count = service.preprocessors?.pagingPreprocessor?.count));
							vm.results = vm.results.filter((a) => a.Count > 0).sort((a, b) => b.Count - a.Count);
							//timeout to reorder tabs in ui tabs component and to avoid double change of selectedIndex
							setTimeout(resolve, 200);
						}
					});
				},
				$scope
			);
		});
	}

	async function changeTabContext(tabIndex) {
		if (!isFinite(tabIndex) || !vm.results) {
			return;
		}

		const newContext = vm.results[tabIndex];

		if (newContext === vm.currentContext) {
			return;
		}

		if (vm.currentContext) {
			vm.currentContext.selectedObjects = contextService.selectedObjects;
		}

		vm.currentContext = newContext;
		contextService.selectedObjects = vm.currentContext.selectedObjects || [];

		searchService.currentSearch(vm.currentContext.searchOptions);
		eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged);

		if (!vm.currentContext.templateLoaded) {
			await vm.currentContext.load();
		}
	}

	function makeTemplateLoader(result) {
		result.load = function () {
			const widgetList = result.ContentWidgetList;

			return $q
				.when(null, function () {
					return widgetList.Template
						? widgetList.Template
						: contentWidgetService.getHtml(result.WidgetId).then(function (t) {
								return t.Template;
						  });
				})
				.then(function (template) {
					const view =
						(widgetList.ListViewEnabled || widgetList.TileViewEnabled) &&
						template.Views.filter(function (view) {
							return view.Type === widgetList.DefaultView;
						})[0];

					result.view = view ? view : mx.SolutionBuilderAgent.ContentWidgetViewType.Grid;

					const dataModelExtensions = template.DataModelExtensions;
					const dataModelOptions = dataModelExtensions
						? JSON.parse(dataModelExtensions)
						: {
								Sources: [],
								Properties: [],
						  };
					dataModelOptions.dataQueryId = result.DataQueryId;
					dataModelOptions.widgetId = result.WidgetId;
					const staticData = {
						Context: {
							WidgetId: result.WidgetId,
							NavigationId: result.navigationId,
							IsGlobalSearch: true,
						},
					};
					result.viewParameters.dataModelOptions = dataModelExtensions;
					return dataModelService.loadDataModel(dataModelOptions, staticData, undefined, freeDataSourceDefer.promise);
					//
				})
				.then(function (dataModel) {
					result.viewParameters.dataModel = dataModel;
					result.templateLoaded = true;
				});
		};
	}

	function makeItemForQueryInfo(userProfile) {
		return function (item) {
			let sorting;
			const sortingConfig = storage.getAsObject('ds_sort_' + item.dataQueryId);
			if (sortingConfig && sortingConfig.field) {
				sorting = sortingConfig.field + ' ' + sortingConfig.direction;
			} else {
				const p = personalizationService.getGridPersonalizationStorageKeyByProfile(item.widgetId, userProfile);
				const config = storage.getAsObject(p);
				_.forIn(config, function (value, key) {
					if (value.Sorting && key) {
						sorting = key + ' ' + (value.Sorting === 1 ? 'asc' : 'desc');
					}
				});
			}
			return {
				dataQueryId: item.dataQueryId,
				widgetId: item.widgetId,
				filters: item.filterType === 'filter' && item.filterId ? [item.filterId] : [],
				structureNodeId: (item.filterType === 'structure' && item.filterId) || '',
				orderBy: sorting,
			};
		};
	}

	function mapContextToQuery(context) {
		return {
			dataQueryId: context.datasource,
			widgetId: context.navigationItem.contentWidgetId,
			navigationId: context.parameters.navigationId,
			title: context.title,
			name: context.name,
			filterId: context.parameters.filterId,
			filterType: context.parameters.filterType,
		};
	}
}
